import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from "recharts";

export default function VolumeChart({ weeks }) {
  if (!weeks || weeks.length === 0) return null;

  const data = weeks.map((w) => {
    let swimMin = 0, bikeMin = 0, runMin = 0;
    for (const day of w.days || []) {
      for (const wo of day.workouts || []) {
        if (wo.sport === "swim") swimMin += wo.duration_min || 0;
        else if (wo.sport === "bike") bikeMin += wo.duration_min || 0;
        else if (wo.sport === "run") runMin += wo.duration_min || 0;
      }
    }
    return {
      name: `T${w.week}`,
      phase: w.phase,
      Bơi: +(swimMin / 60).toFixed(1),
      Đạp: +(bikeMin / 60).toFixed(1),
      Chạy: +(runMin / 60).toFixed(1),
    };
  });

  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload) return null;
    const total = payload.reduce((s, p) => s + (p.value || 0), 0);
    return (
      <div className="bg-white p-3 rounded-lg shadow-lg border border-slate-200 text-sm">
        <p className="font-bold mb-1">{label} - Tổng: {total.toFixed(1)}h</p>
        {payload.map((p, i) => (
          <p key={i} style={{ color: p.fill }} className="flex justify-between gap-4">
            <span>{p.name}</span>
            <span className="font-semibold">{p.value}h</span>
          </p>
        ))}
      </div>
    );
  };

  return (
    <div data-testid="volume-chart" className="w-full">
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 5 }}>
          <XAxis dataKey="name" tick={{ fontSize: 10 }} />
          <YAxis tick={{ fontSize: 10 }} unit="h" />
          <Tooltip content={<CustomTooltip />} />
          <Legend iconSize={10} wrapperStyle={{ fontSize: 11 }} />
          <Bar dataKey="Bơi" stackId="a" fill="#0EA5E9" radius={[0, 0, 0, 0]} />
          <Bar dataKey="Đạp" stackId="a" fill="#22C55E" />
          <Bar dataKey="Chạy" stackId="a" fill="#EF4444" radius={[2, 2, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
